import React from 'react'

const TwoCards = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.75 7.41973L9.79 4.04973C8.9 3.81973 7.98 4.34973 7.75 5.24973L6.78 8.99973H20.2C21.45 8.99973 22.53 9.69973 23.09 10.7197C23.22 10.9497 23.58 10.8897 23.64 10.6297L23.95 9.44973C24.18 8.55973 23.65 7.64973 22.75 7.41973Z"
        fill="#1072EB"
      />
      <path
        d="M20.21 10.4997H5.8C4.81 10.4997 4 11.3097 4 12.2997V21.2997C4 22.2897 4.81 23.0997 5.8 23.0997H20.2C21.19 23.0997 22 22.2897 22 21.2997V12.2997C22.01 11.3097 21.2 10.4997 20.21 10.4997ZM18.51 21.0997C18.13 21.0997 17.78 20.9497 17.52 20.7197C17.44 20.6497 17.33 20.6497 17.25 20.7197C16.99 20.9597 16.64 21.0997 16.26 21.0997C15.43 21.0997 14.76 20.4297 14.76 19.5997C14.76 18.7697 15.43 18.0997 16.26 18.0997C16.64 18.0997 16.99 18.2497 17.25 18.4797C17.33 18.5497 17.44 18.5497 17.52 18.4797C17.78 18.2397 18.13 18.0997 18.51 18.0997C19.34 18.0997 20.01 18.7697 20.01 19.5997C20.01 20.4297 19.33 21.0997 18.51 21.0997Z"
        fill="#1072EB"
      />
    </svg>
  )
}

export default TwoCards
